
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateSupplierFromLindasDtoFormGroup() {
return new FormGroup({
    year: new FormControl<number | undefined>(undefined, [Validators.required]),
    cantonCode: new FormControl<string | undefined>(undefined),
    supplierId: new FormControl<number | undefined>(undefined),
    electricityCategoryName: new FormControl<string | undefined>(undefined),
    updateSuppliers: new FormControl<boolean | undefined>(false),
    updateLocations: new FormControl<boolean | undefined>(false),
    updatePrices: new FormControl<boolean | undefined>(false),
    createIfNotExist: new FormControl<boolean | undefined>(false),
})
;
}
      